<script setup lang="ts">
    import UserInfo from '@/components/UserInfo.vue';
    import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar';
    import { type SharedData, type User } from '@/types';
    import { usePage } from '@inertiajs/vue3';
    import { Link } from '@inertiajs/vue3';

    const page = usePage<SharedData>();
    const user = page.props.auth.user;
</script>

<template>
    <SidebarMenu>
        <SidebarMenuItem>
            <SidebarMenuButton
                as-child
                size="lg"
                class="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground cursor-pointer"
                :is-active="route('v2.profile.index') === page.props.ziggy.location"
            >
                <Link :href="route('v2.profile.index')">
                    <UserInfo :user="user" />
                </Link>
            </SidebarMenuButton>
        </SidebarMenuItem>
    </SidebarMenu>
</template>
